import React from "react";
import PageHeader from "./PageHeader";
import AnnouncementList from "../components/AnnouncementList";


const Notification = () => {
  return (
    <div>
      <PageHeader
        title="Announcements"
        bgImage="assets/img/about-img.png"
      />

      <section className="announcement-section py-5">
        <div className="container">
          <AnnouncementList />
        </div>
      </section>
    </div>
  );
};

export default Notification;